import React from 'react';

function Button({ href, text, color = '#000', bgColor = '#5371FF', textColor = 'white' }) {
  return (
    <a
      href={href}
      className={`inline-block w-[131px] h-[40px] min-w-full text-center leading-[40px] uppercase transition-transform duration-200 hover:scale-105 font-bold`}
      style={{
        backgroundColor: bgColor,
        color: textColor,
        border: `3px solid ${color}`,
        boxShadow: `-4px 4px 0 0 ${bgColor}`,
      }}
    >
      {text}
    </a>
  );
}

export default Button;
